module.exports = __webpack_public_path__ + "static/media/insulation_allImpact_10y_y.bb8b6df0.csv";